import axiosClient from "./axiosClient";
import { IUpdatePayRateDTO } from "../interfaces/IUpdatePayRateDTO";
import { IRateDTO, IRateUpsertDTO } from "../interfaces/IRateDTO";

export function saveRate(data: Partial<IUpdatePayRateDTO>) {
  return axiosClient.post<{ status: string; message: string }>(
    "/pay_rate/add",
    data
  );
}

export function fetchWorkerPayRates(workerId: number): Promise<IRateDTO[]> {
  return axiosClient
    .get<IRateDTO[]>(`/pay_rate/worker/${workerId}/list`)
    .then((res) => res.data);
}

export function updatePayRate(rateId: number, data: IRateUpsertDTO) {
  return axiosClient.put<{ status: string; message: string }>(
    `/pay_rate/${rateId}`,
    data
  );
}

export function createPayRate(data: Partial<IUpdatePayRateDTO>) {
  return axiosClient.post<{ status: string; message: string }>(
    "/pay_rate/add",
    data
  );
}
